import { render, staticRenderFns } from "./TournamentEventSmartGenerator.vue?vue&type=template&id=5a1f0220&scoped=true&"
import script from "./TournamentEventSmartGenerator.vue?vue&type=script&lang=js&"
export * from "./TournamentEventSmartGenerator.vue?vue&type=script&lang=js&"
import style0 from "./TournamentEventSmartGenerator.vue?vue&type=style&index=0&id=5a1f0220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1f0220",
  null
  
)

component.options.__file = "TournamentEventSmartGenerator.vue"
export default component.exports